import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@libs/rubick";
import { ServerIcon, ClusterIcon } from "@libs/rubick";
import { PlusIcon } from "@heroicons/react/24/outline";
export function InitializationView({ onCreateCluster, onJoinCluster }) {
    return /*#__PURE__*/ _jsx("div", {
        className: "flex items-center justify-center p-8 min-h-[calc(100vh-8rem)]",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "max-w-4xl w-full",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mb-12",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex justify-center mb-4",
                            children: /*#__PURE__*/ _jsx(ServerIcon, {
                                className: "w-16 h-16"
                            })
                        }),
                        /*#__PURE__*/ _jsx("h1", {
                            className: "text-3xl font-bold text-gray-900 mb-2",
                            children: "Cluster Configuration"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-gray-600",
                            children: "This appliance is not part of a cluster. Choose an option below to get started."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "grid md:grid-cols-2 gap-6",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow text-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex justify-center mb-4",
                                    children: /*#__PURE__*/ _jsx(PlusIcon, {
                                        className: "h-16 w-16 text-green-600"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "text-xl font-semibold text-gray-900 mb-3",
                                    children: "Create Cluster"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Initialize a new cluster with this node as the control plane. Other nodes can join this cluster later."
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "simple",
                                    color: "navy-90",
                                    onClick: onCreateCluster,
                                    className: "w-full",
                                    children: "Create Cluster"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "bg-white rounded-lg shadow-md p-8 hover:shadow-lg transition-shadow text-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex justify-center mb-4",
                                    children: /*#__PURE__*/ _jsx(ClusterIcon, {
                                        className: "h-16 w-16 fill-blue-600"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "text-xl font-semibold text-gray-900 mb-3",
                                    children: "Join Existing Cluster"
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-gray-600 mb-6",
                                    children: "Connect this node to an existing cluster using the control plane URL and joining token."
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "simple",
                                    color: "navy-90",
                                    onClick: onJoinCluster,
                                    className: "w-full",
                                    children: "Join Cluster"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
